export class ShadowConstraint {
    id: string;
    deviceVersion: string;
    deviceVersionId: string;
    field: string;
    constraintTypeId: number;
    constraintType: string;
    operatorTypeId: number;
    operatorType: string;
    operatorValue: string;
    operatorTypeId2: number;
    operatorType2: string;
    operatorValue2: string;
}
